var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from "react";
import { ButtonPrimary } from "../generic/common/ButtonPrimary";
import { HOCTimer } from "../generic/timer/HOCTimer";
import { HOCProgressDelay } from "./HOCProgressDelay";
import { IdButtonWithProgressFill } from "./IdButtonWithProgressFill";
var ButtonWithProgress = /** @class */ (function (_super) {
    __extends(ButtonWithProgress, _super);
    function ButtonWithProgress() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ButtonWithProgress.prototype.render = function () {
        var _a = this.props, _b = _a.component, ButtonComponent = _b === void 0 ? ButtonPrimary : _b, _c = _a.fillClass, fillClass = _c === void 0 ? IdButtonWithProgressFill.Primary : _c, duration = _a.duration, delay = _a.delay, children = _a.children, props = __rest(_a, ["component", "fillClass", "duration", "delay", "children"]);
        var buttonStyle = {
            animationDelay: "-" + delay + "s",
            animationDuration: duration + "s",
            opacity: 1,
        };
        return (React.createElement(ButtonComponent, __assign({}, props),
            React.createElement("div", { className: fillClass + " button-with-progress", style: buttonStyle }, children)));
    };
    ButtonWithProgress = __decorate([
        HOCTimer(true),
        HOCProgressDelay()
    ], ButtonWithProgress);
    return ButtonWithProgress;
}(React.Component));
export { ButtonWithProgress };



//////////////////
// WEBPACK FOOTER
// ./src/features/button-with-progress/ButtonWithProgress.tsx
// module id = 602
// module chunks = 3